export const serviceStatus = [
  { label: "Por comenzar", value: "Por comenzar" },
  { label: "En proceso", value: "En proceso" },
  { label: "Congelado", value: "Congelado" },
  { label: "Abandonado", value: "Abandonado" },
  { label: "Terminado con éxito", value: "Terminado con exito" },
]

export const webServiceStatus = [
  { icon: "🟡", label: "Por comenzar", value: "Por comenzar", color: "text-yellow-300" },
  { icon: "🔵", label: "En proceso", value: "En proceso", color: "text-blue-500" },
  { icon: "🔴", label: "Falta pagar", value: "Falta pagar", color: "text-red-500" },
  { icon: "🟠", label: "Cotizando", value: "Cotizando nuevas funciones", color: "text-orange-400" },
  { icon: "🔘", label: "Falta migrar", value: "Falta migrar", color: "text-gray-500" },
  { icon: "🧊", label: "Congelado", value: "Congelado", color: "text-sky-300" },
  { icon: "⚫", label: "Abandonado", value: "Abandonado", color: "text-black" },
  { icon: "🟢", label: "Éxito", value: "Terminado con exito", color: "text-green-500" },
]

export const standardServiceStatus = [
  { icon: "🟡", label: "Por comenzar", value: "Por comenzar", color: "text-yellow-300" },
  { icon: "🔵", label: "En proceso", value: "En proceso", color: "text-blue-500" },
  { icon: "🔴", label: "Falta pagar", value: "Falta pagar", color: "text-red-500" },
  { icon: "🟠", label: "Cotizando", value: "Cotizando nuevas funciones", color: "text-orange-400" },
  { icon: "🧊", label: "Congelado", value: "Congelado", color: "text-sky-300" },
  { icon: "⚫", label: "Abandonado", value: "Abandonado", color: "text-black" },
  { icon: "🟢", label: "Éxito", value: "Terminado con exito", color: "text-green-500" },
]